import React, {useState, useRef, useEffect} from 'react';

// 3-dot action menu shown beside a supplier's name on the Pricing Comparison page
// (specs/010-pricing-comparison-enhancements US3/US4, FR-009). No dropdown/menu component exists
// elsewhere in this React tree and no menu library is in package.json, so this is a small
// self-contained implementation rather than a new dependency (research.md Decision 8).
export default function SupplierActionsMenu({i18n, onReject, onMessage}) {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="d-inline-block" ref={containerRef} style={{position: 'relative'}}>
            <button
                type="button"
                className="btn btn-sm outline-button"
                aria-label={i18n.labelSupplierActions}
                onClick={() => setOpen((prev) => !prev)}
            >
                <i className="fas fa-ellipsis-v"/>
            </button>
            {open && (
                <div className="dropdown-menu dropdown-menu-right show" style={{position: 'absolute', right: 0, top: '100%', zIndex: 10}}>
                    <button
                        type="button"
                        className="dropdown-item"
                        onClick={() => {
                            setOpen(false);
                            onMessage();
                        }}
                    >
                        {i18n.labelMessage}
                    </button>
                </div>
            )}
        </div>
    );
}
